<section>
  <h1 class="header-1">{{ 'home.title' | translate }}</h1>
  {{ 'home.message' | translate}}
</section>